import React from 'react';
import { Link } from 'react-router-dom';
import { X, ChevronDown, ArrowRight } from 'lucide-react';

const INDUSTRY_LINKS = [
  { to: '/mining', label: 'Mining' },
  { to: '/cement', label: 'Cement & Materials' },
  { to: '/energy', label: 'Energy & Power' },
  { to: '/oil-gas', label: 'Oil & Gas' },
  { to: '/manufacturing', label: 'Manufacturing' },
  { to: '/machinery', label: 'Machinery & OEM' },
  { to: '/construction', label: 'Construction' },
];

const OFFERING_LINKS = [
  { to: '/offerings#fractional', label: 'Fractional Head of Data & AI' },
  { to: '/offerings#pillar-01', label: 'Advise' },
  { to: '/offerings#pillar-02', label: 'Strategy & Program' },
  { to: '/offerings#pillar-03', label: 'Data & Platform' },
  { to: '/offerings#pillar-04', label: 'Build & Deploy' },
  { to: '/offerings#pillar-05', label: 'Adopt, Operate & Hand Over' },
];

export const MobileMenu = ({ expanded, setExpanded, onClose }) => {
  const toggleSection = (name) => setExpanded(expanded === name ? null : name);

  return (
    <div className="mobile-fullscreen-menu">
      <div className="mobile-menu-header">
        <img src="/logos/aplied-logo-dark.png" alt="APLIED.AI" className="mobile-menu-logo" />
        <button
          className="mobile-menu-close"
          onClick={onClose}
          aria-label="Close menu"
        >
          <X size={28} />
        </button>
      </div>

      <nav className="mobile-menu-content" id="primary-nav">
        <div className="mobile-menu-section mobile-menu-accordion">
          <button
            className="mobile-menu-link mobile-menu-link--toggle"
            onClick={() => toggleSection('industries')}
            aria-expanded={expanded === 'industries'}
            data-testid="mobile-toggle-industries"
          >
            <span>Industries</span>
            <ChevronDown size={20} className={expanded === 'industries' ? 'rotated' : ''} />
          </button>
          {expanded === 'industries' && (
            <div className="mobile-menu-sub" data-testid="mobile-sub-industries">
              <div className="mobile-menu-sub-divider">Heavy Industry</div>
              {INDUSTRY_LINKS.map((link) => (
                <Link key={link.to} to={link.to} className="mobile-menu-sublink" onClick={onClose}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className="mobile-menu-section mobile-menu-accordion">
          <button
            className="mobile-menu-link mobile-menu-link--toggle"
            onClick={() => toggleSection('offerings')}
            aria-expanded={expanded === 'offerings'}
            data-testid="mobile-toggle-offerings"
          >
            <span>Offerings</span>
            <ChevronDown size={20} className={expanded === 'offerings' ? 'rotated' : ''} />
          </button>
          {expanded === 'offerings' && (
            <div className="mobile-menu-sub" data-testid="mobile-sub-offerings">
              {OFFERING_LINKS.map((link) => (
                <Link key={link.to} to={link.to} className="mobile-menu-sublink" onClick={onClose}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className="mobile-menu-section">
          <Link
            to="/capabilities"
            className="mobile-menu-link"
            onClick={onClose}
            data-testid="mobile-nav-capabilities"
          >
            Capabilities
          </Link>
        </div>

        <div className="mobile-menu-section">
          <Link
            to="/about"
            className="mobile-menu-link"
            onClick={onClose}
            data-testid="mobile-nav-about"
          >
            About
          </Link>
        </div>

        <div className="mobile-menu-section mobile-menu-cta-wrap">
          <Link
            to="/book-a-meeting"
            className="mobile-menu-cta-pill"
            onClick={onClose}
            data-testid="mobile-nav-book-meeting"
          >
            Book a meeting
            <ArrowRight size={18} />
          </Link>
        </div>
      </nav>
    </div>
  );
};
